import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../../actionTypes';

const initialState = false;

const show = () => true;
const hide = () => false;

export default createReducer(initialState, {
  [types.DISPLAY_UNPUBLISH_MODAL]: show,
  [types.HIDE_UNPUBLISH_MODAL]: hide,
  [types.PATCH_AUDIT_MODEL_STATUS_SUCCESS]: hide,
});
